import { actions, actionTypes, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { TransactionType } from 'data/Payments/Transactions/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import * as payments from '../../../services/api/payments'
import buildApiRequest from './buildApiRequest'

const submit = function* (action) {
  const config = yield select(selectors.config.getConfig)
  const twoFactorStatus = yield select(selectors.auth.getTwoFactorStatus)
  const challenge = yield select(
    selectors.auth.secondFactorChallenge.getCurrentSecondFactorChallenge
  )
  // If 2FA was WALLET_SMS we need to send the challenge id we requested while
  // rendering the form
  const challengeId =
    twoFactorStatus && twoFactorStatus[0] === 'WALLET_SMS' ? challenge?.challengeId : undefined
  const request = buildApiRequest(action.payload, config.memoTokens)
  const data = yield call(payments.withdraw, {
    ...request,
    twoFaChallengeId: challengeId
  })

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    yield put(actions.withdrawal.submitError())
    return
  }

  yield put(actions.withdrawal.submitSuccess(data.response))
  yield put(actions.payments.transactions.fetch(TransactionType.WITHDRAWAL))
}

export default function* withdrawalForm() {
  yield takeEvery(actionTypes.withdrawal.SUBMIT, submit)
}
